import 'theme/moydom/less/pages/city-notification.less';

import $ from 'jquery';

$(() => {});
